export enum MOTIV_TYPE {
  HIRE_PURCHASE = 'HirePurchase',
  UNSECURED = 'Unsecured',
  GUARANTOR = 'Guarantor',
  CONDITIONAL_SALE = 'ConditionalSale',
  PCP = 'PCP',
  HIRE_PURCHASE_BALLOON = 'HirePurchaseBalloon',
  LEASE = 'Lease',
  SUMMARY = 'Summary',
}
